import { shipmentApiClient } from '../shipmentApiClient'
import { createShipmentEndpoint } from './endpoint'
import type { CreateShipmentParams, CreateShipmentRequest, CreateShipmentResponse } from './type'

export const createShipment = async (params: CreateShipmentParams) => {
  const body: CreateShipmentRequest = {
    delivery_report_uid: params.deliveryReportUid,
    driver_phone: params.driverPhone,
  }
  const { data } = await shipmentApiClient.post<CreateShipmentResponse>(
    createShipmentEndpoint,
    body
  )
  return data
}
